<script setup lang="ts">
import VarsityInlineConfirm from "@/components/VarsityInlineConfirm.vue"
import VarsityInlineConfirmButton from "@/components/VarsityInlineConfirmButton.vue"
import VarsityInlineConfirmGroup from "@/components/VarsityInlineConfirmGroup.vue"
import { useLegacyHttpClient } from "@/composables/compat/useLegacyHttpClient"
import { createInlineConfirm } from "@/composables/createInlineConfirm"
import { type Invitation } from "@/model/app/invitation"
import { type TasksProps } from "@/pages/Tasks/Tasks/tasks-props"

const props = defineProps<TasksProps<Invitation>>()

const emit = defineEmits<{
    (e: "updated"): void
}>()

const http = useLegacyHttpClient()
const inlineConfirmAccept = createInlineConfirm({
    async action() {
        await http.post(`/invitation/${props.task.token}/accept`, {})
    },
    afterAction() {
        emit("updated")
    },
})

const inlineConfirmDecline = createInlineConfirm({
    async action() {
        await http.post(`/invitation/public/${props.task.token}/decline`, {})
    },
    afterAction() {
        emit("updated")
    },
})
</script>

<template>
    <div class="mt-4">
        <VarsityInlineConfirmGroup>
            <VarsityInlineConfirmButton class="btn btn-success btn-shape-skewed" :controller="inlineConfirmAccept">
                {{ $t("@tasks:tasks.account_invitation.accept") }}
            </VarsityInlineConfirmButton>
            <VarsityInlineConfirmButton class="btn btn-danger btn-shape-skewed" :controller="inlineConfirmDecline">
                {{ $t("@tasks:tasks.account_invitation.decline") }}
            </VarsityInlineConfirmButton>

            <VarsityInlineConfirm :controller="inlineConfirmAccept">
                <template #confirmation>{{ $t("@tasks:tasks.account_invitation.accept_confirm") }}</template>
                <template #success>{{ $t("@tasks:tasks.account_invitation.accept_successfull") }}</template>
            </VarsityInlineConfirm>

            <VarsityInlineConfirm :controller="inlineConfirmDecline">
                <template #confirmation>{{ $t("@tasks:tasks.account_invitation.decline_confirm") }}</template>
                <template #success>{{ $t("@tasks:tasks.account_invitation.decline_successfull") }}</template>
            </VarsityInlineConfirm>
        </VarsityInlineConfirmGroup>
    </div>
</template>
